import createIcon from '../../createIcon';

/**
 * @component @name AccessibilityNew
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSA2QzE3Ljg5IDYuNyAxNC44MyA3IDEyIDdDOS4xNyA3IDYuMTEgNi43IDMuNSA2TDMgOEM0Ljg2IDguNSA3IDguODMgOSA5VjIySDExVjE2SDEzVjIySDE1VjlDMTcgOC44MyAxOS4xNCA4LjUgMjEgOEwyMC41IDZaTTEyIDZDMTMuMSA2IDE0IDUuMSAxNCA0QzE0IDIuOSAxMy4xIDIgMTIgMkMxMC45IDIgMTAgMi45IDEwIDRDMTAgNS4xIDEwLjkgNiAxMiA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccessibilityNew = createIcon('AccessibilityNew', [
  [
    'path',
    {
      d: 'M20.5 6C17.89 6.7 14.83 7 12 7C9.17 7 6.11 6.7 3.5 6L3 8C4.86 8.5 7 8.83 9 9V22H11V16H13V22H15V9C17 8.83 19.14 8.5 21 8L20.5 6ZM12 6C13.1 6 14 5.1 14 4C14 2.9 13.1 2 12 2C10.9 2 10 2.9 10 4C10 5.1 10.9 6 12 6Z',
      key: '1azazh',
    },
  ],
]);

export default AccessibilityNew;
